import React, { useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const ManagePocForm = ({
  handleValue,
  pocById,
  id,
  siteId,
  clientId,
  noTitle,
}) => {
  const pocInputs = {
    site_id: '',
    client_id: '',
    poc_name: '',
    poc_designation: '',
    poc_contact_no: '',
    poc_email: '',
  };
  const editInputs = {
    id: '',
    poc_name: '',
    poc_designation: '',
    poc_contact_no: '',
    poc_email: '',
  };
  const [editVal, setEditVal] = useState(editInputs);
  const [pocData, setPocData] = useState(pocInputs);

  const handlePocData = () => {
    if (
      pocData.poc_name !== '' &&
      pocData.poc_designation !== '' &&
      pocData.poc_contact_no !== '' &&
      pocData.poc_email !== ''
    ) {
      if (id) {
        handleValue({
          id: pocById.id,
          poc_name: editVal.poc_name,
          poc_designation: editVal.poc_designation,
          poc_contact_no: editVal.poc_contact_no,
          poc_email: editVal.poc_email,
          status: 1,
        });
      } else {
        handleValue({
          ...pocData,
          site_id: siteId,
          client_id: clientId,
          poc_name: pocData.poc_name,
          poc_designation: pocData.poc_designation,
          poc_contact_no: pocData.poc_contact_no,
          poc_email: pocData.poc_email,
        });
      }
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handlePocData();
  }, [pocData]);

  useEffect(() => {
    if (pocById !== editVal) {
      setEditVal(pocById);
    }
  }, [pocById]);

  useEffect(() => {
    if (id) {
      handleValue({
        id: pocById.id,
        poc_name: editVal.poc_name,
        poc_designation: editVal.poc_designation,
        poc_contact_no: editVal.poc_contact_no,
        poc_email: editVal.poc_email,
        status: 1,
      });
    }
  }, [editVal]);

  return (
    <FormSection
      title={
        id
          ? localization.editPocDetail
          : noTitle
          ? ''
          : localization.pocDetailTitle
      }
    >
      <ConstantInput
        value={editVal?.poc_name || pocData.poc_name}
        label={localization.POCName}
        regex={Regex.text.test(editVal?.poc_name || pocData.poc_name)}
        errorMsg={localization.requiredPocName}
        type="text"
        required
        isStarRequired={true}
        handleChange={(value) => {
          setPocData({ ...pocData, poc_name: value });
          setEditVal({ ...editVal, poc_name: value });
        }}
      />
      <ConstantInput
        value={editVal?.poc_designation || pocData.poc_designation}
        label={localization.POCDesignation}
        regex={Regex.text.test(
          editVal?.poc_designation || pocData.poc_designation
        )}
        errorMsg={localization.requiredPocDesig}
        type="text"
        required
        isStarRequired={true}
        handleChange={(value) => {
          setPocData({ ...pocData, poc_designation: value });
          setEditVal({ ...editVal, poc_designation: value });
        }}
      />
      <ConstantInput
        value={id ? `${editVal?.poc_contact_no}` : pocData.poc_contact_no}
        label={localization.phoneNumber}
        regex={Regex.phoneNumber.test(
          editVal?.poc_contact_no || pocData.poc_contact_no
        )}
        errorMsg={localization.phoneError}
        maxLength={10}
        minLength={10}
        type="text"
        isPrefix
        prefixText={'+91'}
        required
        isStarRequired={true}
        handleChange={(value) => {
          setPocData({ ...pocData, poc_contact_no: value });
          setEditVal({ ...editVal, poc_contact_no: value });
        }}
      />
      <ConstantInput
        value={editVal?.poc_email || pocData.poc_email}
        label={localization.emailAddress}
        regex={Regex.email.test(editVal?.poc_email || pocData.poc_email)}
        errorMsg={localization.emailError}
        type="email"
        required
        isStarRequired={true}
        handleChange={(value) => {
          setPocData({ ...pocData, poc_email: value });
          setEditVal({ ...editVal, poc_email: value });
        }}
      />
    </FormSection>
  );
};

export default ManagePocForm;
